// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ant-input[disabled],\n.ant-input-disabled,\n.ant-input-number-disabled,\n.ant-select-disabled,\n.ant-btn-disabled,\n.ant-cascader-picker-disabled {\n  color: rgba(0, 0, 0, 0.75) !important;\n}\n\n.ant-transfer-list-body.ant-transfer-list-body-with-search\n  .ant-transfer-list-content {\n  height: 88%;\n}\n\n.ant-drawer-content,\n.ant-drawer-content-wrapper {\n  height: 300px;\n}\n\n.ant-drawer.ant-drawer-content {\n  height: 350px;\n}\n", ""]);
// Exports
module.exports = exports;
